<template>
  <div class="footer-container">
    <div
      class="footer-nav-container"
    >
      <div class="footer-left">
        <svg
          width="264"
          height="34"
          viewBox="0 0 264 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          alt="We, the people, dare to create a more perfect union"
          title="We, the people, dare to create a more perfect union"
          data-v-2b2cff66=""
          data-v-db69c1c8=""
        >
          <path
            d="M3.96 14H7.65L9.936 5.522C10.026 5.198 10.08 4.856 10.098 4.514H10.188C10.206 4.856 10.26 5.198 10.35 5.522L12.636 14H16.326L19.962 1.22H16.65L14.616 9.518C14.526 9.914 14.454 10.274 14.436 10.634H14.382C14.346 10.274 14.256 9.914 14.148 9.518L11.826 1.22H8.478L6.138 9.518C6.03 9.914 5.94 10.274 5.904 10.634H5.85C5.832 10.274 5.76 9.914 5.67 9.518L3.654 1.22H0.342L3.96 14ZM25.3792 11.642V8.618H32.2912V6.35H25.3792V3.578H32.5972V1.22H22.1212V14H32.7232V11.642H25.3792ZM52.2899 1.22H40.2299V3.794H44.6219V14H47.8979V3.794H52.2899V1.22ZM66.9157 1.22H63.6397V6.314H57.5197V1.22H54.2617V14H57.5197V8.726H63.6397V14H66.9157V1.22ZM73.4715 11.642V8.618H80.3835V6.35H73.4715V3.578H80.6895V1.22H70.2135V14H80.8155V11.642H73.4715ZM96.5842 1.22H89.6542V14H92.9122V9.608H96.5122C99.5542 9.608 101.48 7.952 101.48 5.324C101.48 2.804 99.5902 1.22 96.5842 1.22ZM95.7742 7.34H92.9122V3.506H95.7922C97.2322 3.506 98.0422 4.208 98.0422 5.414C98.0422 6.638 97.1962 7.34 95.7742 7.34ZM106.843 11.642V8.618H113.755V6.35H106.843V3.578H114.061V1.22H103.585V14H114.187V11.642H106.843ZM123.075 14.36C127.485 14.36 130.329 11.732 130.329 7.61C130.329 3.488 127.485 0.86 123.075 0.86C118.683 0.86 115.821 3.488 115.821 7.61C115.821 11.714 118.683 14.36 123.075 14.36ZM123.075 11.858C120.717 11.858 119.241 10.202 119.241 7.61C119.241 5 120.717 3.362 123.075 3.362C125.451 3.362 126.927 5 126.927 7.61C126.927 10.22 125.451 11.858 123.075 11.858ZM139.57 1.22H132.64V14H135.898V9.608H139.498C142.54 9.608 144.466 7.952 144.466 5.324C144.466 2.804 142.576 1.22 139.57 1.22ZM138.76 7.34H135.898V3.506H138.778C140.218 3.506 141.028 4.208 141.028 5.414C141.028 6.638 140.182 7.34 138.76 7.34ZM146.571 14H156.489V11.39H149.829V1.22H146.571V14ZM162.036 11.642V8.618H168.948V6.35H162.036V3.578H169.254V1.22H158.778V14H169.38V11.642H162.036ZM0.918 33H4.284C6.984 33 8.406 31.416 8.406 28.41V24.63C8.406 21.75 6.966 20.22 4.302 20.22H0.918V33ZM3.42 31.182V22.038H4.194C5.346 22.038 5.832 22.812 5.832 24.522V28.59C5.832 30.264 5.31 31.182 4.194 31.182H3.42ZM15.0192 33H17.5212L15.0372 20.22H11.7612L9.25917 33H11.7612L12.2292 30.012H14.5512L15.0192 33ZM12.4992 28.194L13.1292 24.162C13.2192 23.55 13.3092 23.028 13.3632 22.344H13.4172C13.4892 23.028 13.5612 23.55 13.6512 24.162L14.2812 28.194H12.4992ZM23.8288 33H26.4388L24.6388 27.204C25.5928 26.736 26.1508 25.764 26.1508 24.252V23.64C26.1328 21.498 25.0888 20.22 22.4248 20.22H19.0228V33H21.5248V27.798H22.4248L23.8288 33ZM21.5248 26.196V21.948H22.2628C23.2168 21.948 23.5768 22.398 23.5768 23.568V24.378C23.5768 25.62 23.2348 26.196 22.2628 26.196H21.5248ZM30.3926 31.074V27.384H33.4706V25.458H30.3926V22.146H33.7226V20.22H27.8906V33H33.8486V31.074H30.3926ZM45.1963 20.22H37.8523V22.344H40.2823V33H42.7663V22.344H45.1963V20.22ZM49.7419 33.306C52.1899 33.306 53.6299 31.866 53.6299 29.256V23.964C53.6299 21.354 52.1899 19.914 49.7419 19.914C47.3119 19.914 45.8719 21.354 45.8719 23.964V29.256C45.8719 31.866 47.3119 33.306 49.7419 33.306ZM49.7419 31.344C48.9139 31.344 48.4459 30.714 48.4459 29.562V23.658C48.4459 22.506 48.9139 21.876 49.7419 21.876C50.5879 21.876 51.0559 22.506 51.0559 23.658V29.562C51.0559 30.714 50.5879 31.344 49.7419 31.344ZM62.2015 33.306C64.5055 33.306 65.8915 32.064 65.8915 29.724V28.338L63.3355 27.816V29.724C63.3355 30.768 62.9395 31.326 62.2015 31.326C61.4275 31.326 61.0135 30.678 61.0135 29.454V23.676C61.0135 22.434 61.4275 21.876 62.2015 21.876C62.9575 21.876 63.3175 22.416 63.3175 23.478V25.188L65.8915 24.702V23.406C65.8915 21.066 64.5775 19.914 62.2555 19.914C59.8075 19.914 58.4395 21.282 58.4395 23.892V29.31C58.4395 31.974 59.7535 33.306 62.2015 33.306ZM72.4738 33H75.0838L73.2838 27.204C74.2378 26.736 74.7958 25.764 74.7958 24.252V23.64C74.7778 21.498 73.7338 20.22 71.0698 20.22H67.6678V33H70.1698V27.798H71.0698L72.4738 33ZM70.1698 26.196V21.948H70.9078C71.8618 21.948 72.2218 22.398 72.2218 23.568V24.378C72.2218 25.62 71.8798 26.196 70.9078 26.196H70.1698ZM79.0376 31.074V27.384H82.1156V25.458H79.0376V22.146H82.3676V20.22H76.5356V33H82.4936V31.074H79.0376ZM89.2129 33H91.7149L89.2309 20.22H85.9549L83.4529 33H85.9549L86.4229 30.012H88.7449L89.2129 33ZM86.6929 28.194L87.3229 24.162C87.4129 23.55 87.5029 23.028 87.5569 22.344H87.6109C87.6829 23.028 87.7549 23.55 87.8449 24.162L88.4749 28.194H86.6929ZM98.605 20.22H91.261V22.344H93.691V33H96.175V22.344H98.605V20.22ZM102.371 31.074V27.384H105.449V25.458H102.371V22.146H105.701V20.22H99.8695V33H105.827V31.074H102.371ZM115.807 33H118.309L115.825 20.22H112.549L110.047 33H112.549L113.017 30.012H115.339L115.807 33ZM113.287 28.194L113.917 24.162C114.007 23.55 114.097 23.028 114.151 22.344H114.205C114.277 23.028 114.349 23.55 114.439 24.162L115.069 28.194H113.287ZM123.177 33H125.301V26.574C125.301 25.548 125.301 24.126 125.247 23.1H125.337C125.355 23.478 125.463 24.18 125.571 24.99L126.939 33H128.739L130.089 24.99C130.215 24.18 130.269 23.712 130.341 23.1H130.413C130.359 24.126 130.359 25.548 130.359 26.574V33H132.519V20.22H129.153L128.091 26.862C128.001 27.546 127.893 28.248 127.893 28.734H127.821C127.803 28.248 127.713 27.546 127.605 26.862L126.525 20.22H123.177V33ZM138.208 33.306C140.656 33.306 142.096 31.866 142.096 29.256V23.964C142.096 21.354 140.656 19.914 138.208 19.914C135.778 19.914 134.338 21.354 134.338 23.964V29.256C134.338 31.866 135.778 33.306 138.208 33.306ZM138.208 31.344C137.38 31.344 136.912 30.714 136.912 29.562V23.658C136.912 22.506 137.38 21.876 138.208 21.876C139.054 21.876 139.522 22.506 139.522 23.658V29.562C139.522 30.714 139.054 31.344 138.208 31.344ZM148.724 33H151.334L149.534 27.204C150.488 26.736 151.046 25.764 151.046 24.252V23.64C151.028 21.498 149.984 20.22 147.32 20.22H143.918V33H146.42V27.798H147.32L148.724 33ZM146.42 26.196V21.948H147.158C148.112 21.948 148.472 22.398 148.472 23.568V24.378C148.472 25.62 148.13 26.196 147.158 26.196H146.42ZM155.288 31.074V27.384H158.366V25.458H155.288V22.146H158.618V20.22H152.786V33H158.744V31.074H155.288ZM167.194 20.22H163.684V33H166.186V28.104H167.248C169.534 28.104 170.794 26.844 170.794 24.558V23.496C170.776 21.336 169.57 20.22 167.194 20.22ZM168.22 24.522C168.22 25.8 167.824 26.34 166.942 26.34H166.186V21.948H166.942C167.824 21.948 168.22 22.434 168.22 23.586V24.522ZM174.737 31.074V27.384H177.815V25.458H174.737V22.146H178.067V20.22H172.235V33H178.193V31.074H174.737ZM184.573 33H187.183L185.383 27.204C186.337 26.736 186.895 25.764 186.895 24.252V23.64C186.877 21.498 185.833 20.22 183.169 20.22H179.767V33H182.269V27.798H183.169L184.573 33ZM182.269 26.196V21.948H183.007C183.961 21.948 184.321 22.398 184.321 23.568V24.378C184.321 25.62 183.979 26.196 183.007 26.196H182.269ZM194.467 22.164V20.22H188.635V33H191.137V27.402H194.215V25.476H191.137V22.164H194.467ZM198.387 31.074V27.384H201.465V25.458H198.387V22.146H201.717V20.22H195.885V33H201.843V31.074H198.387ZM206.678 33.306C208.982 33.306 210.368 32.064 210.368 29.724V28.338L207.812 27.816V29.724C207.812 30.768 207.416 31.326 206.678 31.326C205.904 31.326 205.49 30.678 205.49 29.454V23.676C205.49 22.434 205.904 21.876 206.678 21.876C207.434 21.876 207.794 22.416 207.794 23.478V25.188L210.368 24.702V23.406C210.368 21.066 209.054 19.914 206.732 19.914C204.284 19.914 202.916 21.282 202.916 23.892V29.31C202.916 31.974 204.23 33.306 206.678 33.306ZM218.377 20.22H211.033V22.344H213.463V33H215.947V22.344H218.377V20.22ZM222.899 20.22V29.886C222.899 31.992 224.195 33.306 226.553 33.306C228.893 33.306 230.189 31.992 230.189 29.886V20.22H227.705V29.778C227.705 30.696 227.273 31.2 226.553 31.2C225.797 31.2 225.401 30.696 225.401 29.778V20.22H222.899ZM232.279 33H234.493V26.736C234.493 25.872 234.439 25.08 234.403 24.252H234.457C234.601 24.9 234.763 25.512 235.015 26.268L237.355 33H239.767V20.22H237.571V25.512C237.571 26.466 237.607 27.402 237.661 28.338H237.625C237.481 27.708 237.301 27.06 237.103 26.43L234.961 20.22H232.279V33ZM244.458 33V20.22H241.956V33H244.458ZM250.149 33.306C252.597 33.306 254.037 31.866 254.037 29.256V23.964C254.037 21.354 252.597 19.914 250.149 19.914C247.719 19.914 246.279 21.354 246.279 23.964V29.256C246.279 31.866 247.719 33.306 250.149 33.306ZM250.149 31.344C249.321 31.344 248.853 30.714 248.853 29.562V23.658C248.853 22.506 249.321 21.876 250.149 21.876C250.995 21.876 251.463 22.506 251.463 23.658V29.562C251.463 30.714 250.995 31.344 250.149 31.344ZM255.859 33H258.073V26.736C258.073 25.872 258.019 25.08 257.983 24.252H258.037C258.181 24.9 258.343 25.512 258.595 26.268L260.935 33H263.347V20.22H261.151V25.512C261.151 26.466 261.187 27.402 261.241 28.338H261.205C261.061 27.708 260.881 27.06 260.683 26.43L258.541 20.22H255.859V33Z"
            fill="#FFF"
            data-v-2b2cff66=""
          />
        </svg>
        <div class="link-social">
          <a
            v-for="(link, index) in socialLinks"
            :key="index"
            :href="link.url"
            :class="link.class"
            target="_blank"
          >
            <img
              :src="link.img"
              :alt="link.title"
              :title="link.title"
            >
          </a>
        </div>
        <div class="copyrightblock">
          © 2022 ACLU of Massachusetts
        </div>
        <div class="link-legal">
          <a
            v-for="(link, index) in legalLinks"
            :key="index"
            :href="link.url"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </div>
      </div>
      <div class="link-footer">
        <a
          v-for="(link, index) in footerLinks"
          :key="index"
          :href="link.url"
          target="_blank"
        >
          {{ link.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    activeLang: {
      type: String,
      default: 'English'
    }
  },
  data() {
    return {
      socialLinks: [
        {
          title: 'Follow the ACLU on Facebook',
          url: 'https://www.facebook.com/aclumass/',
          img: require('@/assets/facebook.svg'),
          class: 'facebook-ico'
        },
        {
          title: 'Follow the ACLU on Twitter',
          url: 'https://twitter.com/aclu_mass',
          img: require('@/assets/twitter.svg'),
          class: 'twitter-ico'
        },
        {
          title: 'Follow the ACLU on Instagram',
          url: 'https://www.instagram.com/aclu_mass/',
          img: require('@/assets/instagram.svg'),
          class: 'instagram-ico'
        }
      ],
      legalLinks: [
        {
          url:"https://www.aclum.org/en/user-agreement",
          text:"User Agreement"
        },
        {
          url:"https://www.aclum.org/en/privacy-statement",
          text:"Privacy Statement"
        },
        {
          url:"https://www.aclum.org/en/statement-on-website-accessibility",
          text:"Website Accessibility"
        }
      ],
      footerLinks: [
        {
          url:"https://www.aclum.org/en/contact-us",
          text:"Contact Us"
        },
        {
          url:"https://www.aclum.org/en/media/news-updates",
          text:"News Updates"
        },
        {
          url:"https://www.aclum.org/en/about/careers",
          text:"Careers"
        },
        {
          url:"https://www.aclum.org/en/resources/ways-give",
          text:"Donate"
        },
      ]
    }
  }
}
</script>

<style scoped>
.footer-container {
  color: #fff;
  background-color: #423a38;
  padding: 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-nav-container {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  width: 100%;
  margin-left: 16px;
}

.footer-left {
  text-align: left;
}

.link-social {
  display: flex;
  width: 264px;
  justify-content: space-between;
  margin: 20px 0;
}

.link-social a{
  height: 52px;
  width: 52px;
  display: flex;
  align-items: center;
  border-radius: 100%;
  overflow: hidden;
}

.link-social img {
  align-self: flex-start;
}

.facebook-ico img {
  padding: 11px;
  background-color: #3b5998;
  height: 32px;
  width: 32px;
}

.twitter-ico img {
  padding: 11px;
  background-color: #1da1f2;
  height: 32px;
  width: 32px;
}

.youtube-ico img {
  padding: 8px;
  background-color: #FF0000;
  height: 36px;
  width: 36px;
}

.instagram-ico img {
  padding: 10px;
  background-color: #c32aa3;
  height: 36px;
  width: 36px;
}

.copyrightblock {
  color: #FFF;
  font-weight: 600;
  font-size: 1.2rem;
  text-align: left;
}

.link-legal {
  padding-top: 5px;
  display: flex;
  gap: 20px;
}

.link-legal a {
  font-size: 0.8rem;
  white-space: nowrap;
}

.link-footer {
  margin-bottom: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.link-footer a {
  font-size: 1.5rem;
  white-space: nowrap;
}

a {
  text-decoration: none;
  color: #fff;
}

a:hover {
  color: #92d6e3;
}

@media screen and (min-width: 700px) {
  .footer-nav-container {
    width: 80%;
    margin-left: 0;
  }

  .link-footer {
    flex-direction: row;
    gap: 20px;
  }
}

@media screen and (min-width: 1400px) {
  .footer-nav-container {
    width: 70%;
    max-width: 1200px;
    flex-direction: row;
  }

  .link-footer {
    text-align: right;
  }
}

</style>